export const colors = {
  space: "#1d1e2f",
  "international-orange": {
    "50": "#fff5ed",
    "100": "#ffe7d4",
    "200": "#ffcba8",
    "300": "#ffa770",
    "400": "#ff7637",
    "500": "#ff5818", // primary
    "600": "#f03706",
    "700": "#c72607",
    "800": "#9e1f0e",
    "900": "#7f1d0f",
    "950": "#450b05",
  },
  "purple-heart": {
    "50": "#eef1ff",
    "100": "#dfe4ff",
    "200": "#c6ccff",
    "300": "#a3aafe",
    "400": "#7e7ffb",
    "500": "#695ff5",
    "600": "#4f36e8", // secondary
    "700": "#4d34ce",
    "800": "#3e2da6",
    "900": "#362c83",
    "950": "#211a4c",
  },
  "spring-green": {
    "50": "#edfff7",
    "100": "#d5ffef",
    "200": "#aeffe0",
    "300": "#70ffc9",
    "400": "#2bfdac",
    "500": "#00fa9a", // mediumspringgreen
    "600": "#00c072",
    "700": "#00965c",
    "800": "#06754c",
    "900": "#076040",
    "950": "#003723",
  },
  dandelion: {
    "50": "#fffbeb",
    "100": "#fef2c7",
    "200": "#fde48a",
    "300": "#fcd256",
    "400": "#fbbb24",
    "500": "#f59a0b",
    "600": "#d97306",
    "700": "#b45009",
    "800": "#923e0e",
    "900": "#78330f",
    "950": "#451903",
  },
  "blue-chill": {
    "50": "#f4f9f9",
    "100": "#d9eeee",
    "200": "#b2dddc",
    "300": "#84c3c4",
    "400": "#5ba2a6",
    "500": "#438b90",
    "600": "#32696f",
    "700": "#2b565a",
    "800": "#264549",
    "900": "#233b3e",
    "950": "#102023",
  },
  spray: {
    "50": "#edfdfe",
    "100": "#d2f8fb",
    "200": "#abf0f6",
    "300": "#88e8f2",
    "400": "#2fcde1",
    "500": "#13b0c7",
    "600": "#138da7",
    "700": "#177187",
    "800": "#1b5d6f",
    "900": "#1b4d5e",
    "950": "#0c3240",
  },
  "can-can": {
    "50": "#fbf5f6",
    "100": "#f8ebee",
    "200": "#f1dae0",
    "300": "#e6bbc6",
    "400": "#d795a8",
    "500": "#c56e89",
    "600": "#ae5072",
    "700": "#913f5f",
    "800": "#7a3753",
    "900": "#69324b",
    "950": "#391826",
  },
  cerulean: {
    "50": "#f2f9fd",
    "100": "#e4f1fa",
    "200": "#c3e3f4",
    "300": "#8eceeb",
    "400": "#52b4de",
    "500": "#39a5d4",
    "600": "#1d7cac",
    "700": "#19648b",
    "800": "#185574",
    "900": "#194761",
    "950": "#112d40",
  },
  "golden-sand": {
    "50": "#fdfbed",
    "100": "#faf2cb",
    "200": "#f2df80",
    "300": "#eed15b",
    "400": "#eabe35",
    "500": "#e3a01d",
    "600": "#c87c17",
    "700": "#a75a16",
    "800": "#884718",
    "900": "#703a17",
    "950": "#401e08",
  },
  "amethyst-smoke": {
    "50": "#f8f8fa",
    "100": "#f1f1f6",
    "200": "#e5e5ef",
    "300": "#d1d0e2",
    "400": "#b8b5d0",
    "500": "#a09bbf",
    "600": "#877ea9",
    "700": "#756b96",
    "800": "#61597e",
    "900": "#514a68",
    "950": "#343045",
  },
};

export const knoword = {
  "color-scheme": "light",
  primary: colors["international-orange"][500],
  "primary-content": colors["international-orange"][50],
  secondary: colors["purple-heart"][600],
  "secondary-content": colors["purple-heart"][50],
  accent: colors["spring-green"][500],
  "accent-content": colors["spring-green"][950],
  warning: colors.dandelion[300],
  "warning-content": colors.dandelion[900],
  neutral: "#1f2937", // gray-800
  "neutral-content": "#e5e7eb", // gray-200
  error: "#dc2626", // red-600
  "error-content": "#fef2f2", // red-50
  success: "#22c55e", // green-500
  "success-content": "#f0fff4", // green-50
  info: "#60a5fa", // blue-400
  "info-content": "#172554", // blue-950
  "base-100": "#fff", // white
  "base-200": "#f3f4f6", // gray-100
  "base-300": "#e5e7eb", // gray-200
  "base-content": "#111827", // gray-900
  "--animation-btn": "0",
  "--bg-image": "none",
} as const;

export const dark = {
  ...knoword,
  "color-scheme": "dark",
  primary: colors["international-orange"][300],
  "primary-content": colors["international-orange"][900],
  secondary: colors["purple-heart"][300],
  "secondary-content": colors["purple-heart"][900],
  neutral: "#d1d5db", // gray-300
  "neutral-content": "#1f2937", // gray-800
  error: "#f87171", // red-400
  "error-content": "#450a0a", // red-950
  success: "#4ade80", // green-400
  "success-content": "#052e16", // green-950
  info: "#93c5fd", // blue-300
  "info-content": "#1e3a8a", // blue-900
  "base-100": "#111827", // gray-900
  "base-200": "#1f2937", // gray-800
  "base-300": "#374151", // gray-700
  "base-content": "#f9fafb", // gray-50
  "--bg-image": "none",
};

export const water = {
  ...knoword,
  secondary: colors.spray[600],
  "secondary-content": colors.spray[50],
  "base-100": colors["blue-chill"][100],
  "base-200": colors["blue-chill"][200],
  "base-300": colors["blue-chill"][300],
  "base-content": colors["blue-chill"][900],
  "--bg-image": "url(/themes/water.jpg)",
};

export const hearts = {
  ...knoword,
  secondary: colors["can-can"][600],
  "secondary-content": colors["can-can"][50],
  "base-100": colors["can-can"][100],
  "base-200": colors["can-can"][200],
  "base-300": colors["can-can"][300],
  "base-content": colors["can-can"][900],
  "--bg-image": "url(/themes/hearts.jpg)",
};

export const clouds = {
  ...knoword,
  secondary: colors.cerulean[600],
  "secondary-content": colors.cerulean[50],
  "base-100": colors.cerulean[100],
  "base-200": colors.cerulean[200],
  "base-300": colors.cerulean[300],
  "base-content": colors.cerulean[900],
  "--bg-image": "url(/themes/clouds.jpg)",
};

export const dunes = {
  ...knoword,
  secondary: colors["amethyst-smoke"][600],
  "secondary-content": colors["amethyst-smoke"][50],
  "base-100": colors["golden-sand"][100],
  "base-200": colors["golden-sand"][200],
  "base-300": colors["golden-sand"][300],
  "base-content": colors["golden-sand"][900],
  "--bg-image": "url(/themes/dunes.jpg)",
};

export const themes = {
  knoword,
  dark,
  water,
  hearts,
  clouds,
  dunes,
};

export type Theme = keyof typeof themes;
